export default "__VITE_ASSET__BolHOP7Y__"